"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _HBPopover = _interopRequireDefault(require("../HBPopover/HBPopover"));
var _HBCalloutPopover = require("./HBCalloutPopover.styles");
var _HBCalloutPopoverContent = _interopRequireDefault(require("./HBCalloutPopoverContent/HBCalloutPopoverContent"));
var _excluded = ["openTrigger", "title", "description", "calloutTheme", "primaryActionType", "actions", "mediaPath", "testId", "testIdName", "onClose", "withIcon"];
var HBCalloutPopover = function HBCalloutPopover(_ref) {
  var _ref$openTrigger = _ref.openTrigger,
    openTrigger = _ref$openTrigger === void 0 ? 'click' : _ref$openTrigger,
    title = _ref.title,
    description = _ref.description,
    _ref$calloutTheme = _ref.calloutTheme,
    calloutTheme = _ref$calloutTheme === void 0 ? 'neutral' : _ref$calloutTheme,
    _ref$primaryActionTyp = _ref.primaryActionType,
    primaryActionType = _ref$primaryActionTyp === void 0 ? 'button' : _ref$primaryActionTyp,
    actions = _ref.actions,
    mediaPath = _ref.mediaPath,
    testId = _ref.testId,
    testIdName = _ref.testIdName,
    onClose = _ref.onClose,
    _ref$withIcon = _ref.withIcon,
    withIcon = _ref$withIcon === void 0 ? true : _ref$withIcon,
    popoverProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var styles = (0, _HBCalloutPopover.getCalloutPopoverStyles)()[calloutTheme];
  return /*#__PURE__*/_react["default"].createElement(_HBPopover["default"], (0, _extends2["default"])({
    testId: testId,
    testIdName: testIdName
    // if the dismiss button shows, its the only way to close the popover
    ,
    shouldSupportClickOutside: !onClose,
    customStyle: styles,
    openTrigger: openTrigger || 'hover',
    theme: styles.theme,
    actionsAlignment: "right"
  }, popoverProps), /*#__PURE__*/_react["default"].createElement(_HBCalloutPopoverContent["default"], {
    title: title,
    description: description,
    calloutTheme: calloutTheme,
    primaryActionType: primaryActionType,
    mediaPath: mediaPath,
    actions: actions,
    onClose: onClose,
    testId: testId,
    testIdName: testIdName,
    withIcon: withIcon
  }));
};
var _default = exports["default"] = HBCalloutPopover;
//# sourceMappingURL=HBCalloutPopover.js.map